import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Vehicle } from '../models';
import { DeductibleResponse } from '../models/deductible-response.model';

@Injectable({
    providedIn: 'root'
})
export class VehicleService {

    constructor(private http: HttpClient) { }

    getByPolicyNumber(policyNumber: string): Observable<Vehicle> {
        return this.http.get<Vehicle>(`${environment.server.api.portalpas}/policy/${policyNumber}/vehicle/first`);
    }

    getCarsYearsUntil1990(): Observable<{ code: string, description: string }[]> {
        return this.http.get<{ code: string, description: string }[]>(`${environment.server.api.thirdpartyclaim}/vehicles/years`);
    }

    getCarsYears(initialYear: number = 1971): { key: string, value: string }[] {
        const currentYear = new Date().getFullYear();
        const years = [];

        while (initialYear <= currentYear){
            years.push(initialYear++);
        }

        return years.map(year => { 
            return { key: `${year}`, value: `${year}` };
        }).reverse();
    }

    getCarVersions(makeCode: string, modelCode: string, year: string) {
        return this.http.get<{ carVersions }>(`${environment.server.api.portalpas}/CarVersions?makeCode=${makeCode}&modelCode=${modelCode}&year=${year}`)
            .pipe(map(response => response.carVersions));
    }

    getCarVersionsForSelector(makeCode: string, modelCode: string, year: string, modelName?: string) {
        return this.getCarVersions(makeCode, modelCode, year).pipe(
            map(carVersions => carVersions.map(version => 
                ({ key: version, value: (modelName && `${modelName} `) + version.versionDescription })
            ))
        )
    }

    getDeductibles(vehicleId: string) {
        return this.http.get<DeductibleResponse>(`${environment.server.api.portalpas}/coverable/${vehicleId}/deductibles`);
    }
}